import { object, number } from 'yup';

export const useCreateAdsCampaignOrder = () => {
  const formSchema = object().shape({
    radius: number().min(0).required(),
  });
  return {
    form: { schema: formSchema },
  };
};
